<!-- 报告库 form 组件 -->
<template>
  <h-inspection-page :title="h_i18n('ce7bce56b366d966f2622c8b35332ed4')+data.title" @inspection-update="inspectionUpdate" class="ComponentRohsReport_style">
    <form-header :title="h_i18n('ce7bce56b366d966f2622c8b35332ed4')+data.title" title-height="80px" class="top_wrap_style">
      <template #body>
        <template v-if="kindType == 'sqmModify'">
          <tr>
            <report-td :title="h_i18n('d9a98efd916b2ff29de2ea7815c849d5')" colspan="4:8">{{ getData.testDepartment }}</report-td>
            <report-td :title="h_i18n('e4f67ddee5357ad917b9137da166cdd8')" colspan="4:8">{{ getData.testReportNumber }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('3a9c6c33ba30510928d2b9c0d9660d9c')" colspan="4:8">
              <h-file v-if="getData.fileUuid && getData.fileName" :name="getData.fileName" :delete-type="false" :url="getData.fileUuid" @delete="deleteFun"
              @open="openFile(getData.fileUuid, getData.fileName)" :autoOpen='false'></h-file>
              </report-td>
            <report-td :title="h_i18n('9b9c86d6b2f56e06c784802df22ecbd5')" colspan="4:8">{{ getData.belongTo }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('74406bf625cf3141a81ec2cb00ef753c')" colspan="4:8">{{ time( getData.reportDate) }}</report-td>
            <report-td :title="h_i18n('41f21541fe4cf190f474efd14caf0c1a')" colspan="4:8">{{ time(getData.expriryTime) }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('f0d8154645b18f4ee50e74dadb2607d9')" colspan="4:20">
              <span style="color: #2681ff;cursor: pointer;" @click="openRohsDetectDataDetail">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
            </report-td>
          </tr>
        </template>
        <tr v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
          <report-td :title="h_i18n('4e20e078c1d3a0805446e70bd8b4400b')" colspan="4:8" blueTitleTip frontQuestion required>
            <template #tipText>{{ h_i18n('b60d710740a0f8c78f3d481f899b4730') }}</template>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.testDepartment"
                :content="h_i18n('74d4e28a9e43e36aaa5aee0c97fec3c6')">
                <div></div>
              </el-tooltip>
            <el-select v-model="postData.testDepartment" clearable filterable :placeholder="h_i18n('dd69c6cede1d0a966418b4ba53de3b03')" @blur="enterValue"
              @change="testDepartmentChange">
              <el-option v-for="item in data.testDepartmentList" :key="item.value" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </report-td>
          <report-td :title="h_i18n('0877751ad0ca9072aad13edca6d986d1')" colspan="4:8" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.testReportNumber"
                :content="h_i18n('4ef63fb2a0766fd993aeb383bd1bdbb7')">
                <div></div>
              </el-tooltip>
            <el-input v-model="postData.testReportNumber" @change="getReport" :disabled="data.testReportNumberFlag" v-loading="data.testReportNumberLoading"></el-input>
          </report-td>
        </tr>
        <tr v-if="kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="4:8">{{ getData.supplyCode }}</report-td>
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="4:8">{{ getData.supplyName }}</report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('4e20e078c1d3a0805446e70bd8b4400b')" colspan="4:8">{{ getData.testDepartment }}</report-td>
          <report-td :title="h_i18n('0877751ad0ca9072aad13edca6d986d1')" colspan="4:8">{{ getData.testReportNumber }}</report-td>
        </tr>
        <tr v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
          <report-td :title="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" colspan="4:8" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.fileUuid"
                :content="h_i18n('506ca53a3365fd9217ba87b4347a1636')">
                <div></div>
              </el-tooltip>
              <h-file v-if="postData.fileUuid && postData.fileName" :name="postData.fileName" :delete-type="true" :url="postData.fileUuid" :autoOpen='false'
              @open="openFile(postData.fileUuid,  postData.fileName)" @delete="deleteFun"></h-file>
            <h-button v-else @click="openUploadDialog" type="primary">{{ h_i18n('2b6bc0f293f5ca01b006206c2535ccbc') }}</h-button>
          </report-td>
          <report-td :title="h_i18n('231a2e1471eb62cac39fc761ac0d0761')" colspan="4:8" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.belongTo"
                :content="h_i18n('8b13fc046b6c1324701bb261d9b6af62')">
                <div></div>
              </el-tooltip>
            <el-input v-model="postData.belongTo" clearable :disabled="data.testDepartmentFlag"></el-input>
          </report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" colspan="4:8">
            <h-file v-if="getData.fileUuid && getData.fileName" :name="getData.fileName" :delete-type="false" :url="getData.fileUuid" :autoOpen='false'
            @open="openFile(getData.fileUuid, getData.fileName)"></h-file>
          </report-td>
          <report-td :title="h_i18n('231a2e1471eb62cac39fc761ac0d0761')" colspan="4:8">{{ getData.belongTo }}</report-td>
        </tr>
        <tr v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
          <report-td :title="h_i18n('75cd7f22e38d44007e8ccacf06715b85')" colspan="4:8" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.reportDate"
                :content="h_i18n('21ee12706c2d3d106286a4bc91c29b61')">
                <div></div>
              </el-tooltip>
            <el-date-picker type="date" v-model="postData.reportDate" :placeholder="h_i18n('75cd7f22e38d44007e8ccacf06715b85')" @change="reportDateChange"
              clearable format="YYYY-MM-DD" value-format="YYYY-MM-DD" :disabled="data.testDepartmentFlag">
            </el-date-picker>
          </report-td>
          <report-td :title="h_i18n('f2d9fc762d1d82dee8d1e65edbbdfbdc')" colspan="4:8" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.expriryTime"
                :content="h_i18n('0481ba9f8aa674d1ab7b161979ccc575')">
                <div></div>
              </el-tooltip>
            <el-date-picker type="date" v-model="postData.expriryTime" :placeholder="h_i18n('04a00a5426cc9527dd9e7a8815113158')" :disabled-date="disabledDate"
              clearable format="YYYY-MM-DD" value-format="YYYY-MM-DD" :disabled="data.testDepartmentFlag">
            </el-date-picker>
          </report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('75cd7f22e38d44007e8ccacf06715b85')" colspan="4:8">{{ time(getData.reportDate) }}</report-td>
          <report-td :title="h_i18n('f2d9fc762d1d82dee8d1e65edbbdfbdc')" colspan="4:8">{{ time(getData.expriryTime) }}</report-td>
        </tr>
        <tr v-if="kindType == 'sqmAdd'">
          <report-td :title="h_i18n('63dcc6f9a84f2717e95c7821f47a318c')" colspan="4:8">
            <el-radio-group v-model="postData.isReplace" @change="(v)=>{v == 2,postData.testReportNumberOld = null}">
              <el-radio label="1">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
              <el-radio label="2">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
            </el-radio-group>
          </report-td>
          <report-td :title="h_i18n('e4f67ddee5357ad917b9137da166cdd8')" colspan="4:8" frontQuestion :blueTitleTip="postData.isReplace == '1' ? true : false">
            <template #tipText>{{ h_i18n('bda3a5d31094b52a80d599601bb0d4a3') }}</template>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.testReportNumberOld"
              :content="h_i18n('84dba55c554bd6723ba5c7c61546c586')">
              <div></div>
            </el-tooltip>
            <!-- <el-input v-model="postData.testReportNumberOld" :disabled="postData.isReplace == 2" clearable @change="testReportNumberOldChange"></el-input> -->
            <el-select v-model="postData.testReportNumberOld" :disabled="postData.isReplace == 2" clearable filterable multiple>
              <el-option v-for="item in data.testReportList" :key="item.testReportNumberOld" :label="item.testReportNumberOld" :value="item.testReportNumberOld"></el-option>
            </el-select>
          </report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('337bffab47e921014ae18dea50127fae')" colspan="4:8">
            <span style="color: #2681ff;cursor: pointer;" @click="openRohsDetectDataDetail">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
            &nbsp;&nbsp;
            <span v-if="kindType == 'sqmDetail'" style="color: #2681ff;cursor: pointer;" @click="openRohsDetectDataModify">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</span>
          </report-td>
          <report-td :title="h_i18n('e4f67ddee5357ad917b9137da166cdd8')" colspan="4:8">{{ getData.testReportNumberOld }}</report-td>
        </tr>
        <tr v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
          <report-td :title="kindType == 'sqmModify' ? h_i18n('5875ac378befd1449836c4f0983fd089'):h_i18n('337bffab47e921014ae18dea50127fae')" colspan="4:20" required>
            <el-tooltip effect="redTip" placement="top-start" :disabled="false" :visible="tipFlag.uuid"
                :content="h_i18n('adac6d87277e0a558d80daa153b04cab')">
                <div></div>
              </el-tooltip>
            <span style="color: #2681ff;cursor: pointer;" @click="openRohsDetectDataAdd">{{ h_i18n('c95211a540a0570e8c4b0282b84ee528') }}</span>
          </report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('e080329c020dc42739b9c0a043845712')" colspan="4:8">{{ getData.submitPerson }}</report-td>
          <report-td :title="h_i18n('fb4cc0f776e82afd9c2b6ca157ddc639')" colspan="4:8">{{ getData.submitTime }}</report-td>
        </tr>
        <tr v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
          <report-td :title="h_i18n('2432b57515b3627faddccb1dd1df206e')" colspan="4:20">
            <span style="display:block;color:red;">{{ h_i18n('8fc06f26ac38abb0c0c1eac6df2a0164') }}</span>
            <span style="color:red;display:block;text-overflow: ellipsis;overflow: hidden;">{{ h_i18n('731fd942f08cbe83c02e89ed101908ec') }}</span>
            <span style="color:red;display:block;text-overflow: ellipsis;overflow: hidden;">{{ h_i18n('461aea08aa832883edca686b1f926980') }}</span>
            <span style="color:red;display:block;text-overflow: ellipsis;overflow: hidden;">{{ h_i18n('868216585b3fa39f1bcd05fbe833b96b') }}</span>
            <span style="color:red;display:block;text-overflow: ellipsis;overflow: hidden;">{{ h_i18n('6f531601340b2581be3c0d3074e757e8') }}</span>
            <span style="color:red;display:block;text-overflow: ellipsis;overflow: hidden;">{{ h_i18n('38817fc843070f0d24351a959c873138') }}</span>
          </report-td>
        </tr>
        <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">
          <report-td :title="h_i18n('947d983961bd9a8fcc2ea78818fbd5f1')" colspan="4:20">
            <span v-if="getData.isSynchro == 'Y'" style="display:block;">{{ h_i18n('40888fb461d77c16e8642d2542b677df') }}</span>
            <span v-else style="display:block;">{{ h_i18n('a41c182ba4eacba8662ddb0f93b95b7c') }}</span>
          </report-td>
        </tr>
      </template>
      <div style="padding:20px 0">
        <h-button-group align="center">
          <h-button type="primary" size="small" @click="submit" v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'" :loading="subLoading || data.subLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button type="default" size="small" @click="back">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </form-header>

    <h-dialog class="over_dialog_style" :show="data.fileChoose" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="data.fileChoose = false"
        width="752px">
        <div v-if="data.testDepartmentFlag">
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('28713122dfba9c430042a6aa8c57f96d') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('d6fb0b8b319e445cb3129bf09c07f9e8') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;line-height:28px;padding-left: 28px;">{{ h_i18n('61003266e6138b24da427c7864fab71b') }}<br/>{{ h_i18n('0677d59c2208002e6f0e6c9ce65fc046') }}<br/>{{ h_i18n('7426a8ade6a323b5f2d996ea92b3bd5e') }}<br/>{{ h_i18n('272b6ae246425168f0a45f7a8cbcf6eb') }}</div>
        </el-row>
        <el-row>
          <div style="font-size:14px;height:28px;line-height:28px;padding: 20px 0 20px 28px">
            <!-- 授权操作指导书：-->
            <span style="font-weight:600">{{ h_i18n('09657c8dbdea5c5fb453bd8441a8ba84') }}</span>
            <span v-if="!data.helpBook[postData.testDepartment]">无</span>
            <span v-else style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF">{{ postData.testDepartment+'.pdf' }}</span>
            <!-- data.helpBook[postData.testDepartment] 可以判断如果没有附件的话不展示 授权操作指导书 -->
          </div>
        </el-row>
        <h-button type="primary" @click="getFileUuidAndFileName">{{ h_i18n('6a620e3c07048291fdb26b6edcee7aba') }}</h-button>
      </div>
      <div v-else>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('0285d40023a53d64f40e2ffbadbf384e') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('8c8191107bde15222f40a07c53b74874') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('0be52f201392ee1225a8550c4113dc65') }}</div>
        </el-row>
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('626f03eea2bec1c099651204621ff494') }}</div>
        </el-row>
        <el-row>
          <hc-file-upload download delete v-model="data.fileTemp"
                 accept="all" size="30" :disabled="data.d5"
                :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')" @error="errorFile"
                @delete="deleteFun" @download="download" @change="fileChange">
              </hc-file-upload>
        </el-row>
      </div>
    </h-dialog>

  </h-inspection-page>

</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed, onBeforeUnmount} from "vue";
  import { onBeforeRouteLeave, useRoute } from "vue-router";
  import axios from "axios";
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const emit = defineEmit(
    ['submitBtn','backBtn','submitBtnUpdate']
  )
  const tipFlag = reactive({
    testDepartment:false,
    testReportNumber:false,
    fileUuid:false,
    belongTo:false,
    reportDate:false,
    expriryTime:false,
    uuid:false,
  })
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
    },
    getData: {
      type:Object,
      default: {}
    },
    subLoading:{
      type:Boolean,
      default:false
    }
  })
  const aNewUUID = ref('')
  const data = reactive({
    testReportNumberLoading:false,
    testReportList:[],
    ifAdd:false,
    title:'',
    testDepartmentFlag:false,
    testReportNumberFlag:false,
    testDepartmentList:[
      { value : "通标标准技术服务（天津）有限公司" } ,
      { value : "通标标准技术服务（青岛）有限公司" } ,
      { value : "通标标准技术服务（宁波）有限公司"} ,
      { value : "通标标准技术服务有限公司宁波分公司"} ,
      { value : "通标标准技术服务有限公司宁波分公司"} ,
      { value : "通标标准技术服务（上海）有限公司" } ,
      { value : "通标标准技术服务有限公司广州分公司" } ,
      { value : "上海华测品标检测技术有限公司" } ,
      { value : "华测检测认证集团股份有限公司" } ,
      { value : "宁波市华测检测技术有限公司" } ,
      { value : "苏州市华测检测技术有限公司" } ,
      // { value : "谱尼测试集团股份有限公司" } ,
      { value : "谱尼测试集团深圳有限公司" } ,
      { value : "青岛谱尼测试有限公司" } ,
      { value : "必维申美商品检测（上海）有限公司" } ,
      // { value : "广州广电计量检测股份有限公司" } ,
      // { value : "广州广电计量检测无锡有限公司" } ,
      { value : "广电计量检测（无锡）有限公司" } ,
      { value : "广电计量检测集团股份有限公司" } ,
      { value : "威凯检测技术有限公司"} ,
      { value : "中家院（北京）检测认证有限公司"} ,
      { value : "佛山市沃特测试技术服务有限公司" } ,
      // { value : "斯坦德检测集团股份有限公司" } ,
      { value : "杭州希科检测技术有限公司" } ,
      { value : "南德认证检测（中国）有限公司上海分公司" } ,
      { value : "广州信测标准技术服务有限公司" } ,
      { value : "天津华测检测认证有限公司" } ,
      { value : "东莞市北测标准技术服务有限公司" } ,
      { value : "国高材高分子材料产业创新中心有限公司" } ,
      { value : "上海天祥质量技术服务有限公司" } ,
      { value : "莱茵技术-商检（青岛）有限公司" } ,
    ],
    thirds :[
    "通标标准技术服务（天津）有限公司",
    "通标标准技术服务（青岛）有限公司",
    "通标标准技术服务（宁波）有限公司",
    "通标标准技术服务（上海）有限公司",
    "通标标准技术服务有限公司广州分公司",
    "天津津滨华测产品检测中心有限公司",
    "上海华测品标检测技术有限公司",
    "华测检测认证集团股份有限公司",
    "宁波市华测检测技术有限公司",
    "苏州市华测检测技术有限公司",
    // "谱尼测试集团股份有限公司",
    "谱尼测试集团深圳有限公司",
    "青岛谱尼测试有限公司",
    // "广州广电计量检测股份有限公司",
    // "广州广电计量检测无锡有限公司",
    "广电计量检测（无锡）有限公司",
    "广电计量检测集团股份有限公司",
    "苏州市信测标准技术服务有限公司",
    "东莞市信测科技有限公司",
    "南德认证检测（中国）有限公司深圳分公司",
    // "斯坦德检测集团股份有限公司",
    "佛山市沃特测试技术服务有限公司",
    "威凯检测技术有限公司",
    "中家院（北京）检测认证有限公司",
    "杭州希科检测技术有限公司",
    "南德认证检测（中国）有限公司上海分公司",
    "广州信测标准技术服务有限公司",
    "天津华测检测认证有限公司",
    "东莞市北测标准技术服务有限公司",
    "国高材高分子材料产业创新中心有限公司",
    "上海天祥质量技术服务有限公司",
    "莱茵技术-商检（青岛）有限公司",
    "必维申美商品检测（上海）有限公司",
],
helpBook:{
  // https://sqm.haier.net/readFile/basicInfo/rohshelp/
  // 所有SGS均相同
    "通标标准技术服务（天津）有限公司":"SGS.pdf",
    "通标标准技术服务（青岛）有限公司":"SGS.pdf",
    "通标标准技术服务（宁波）有限公司":"SGS.pdf",
    "通标标准技术服务（上海）有限公司":"SGS.pdf",
    "通标标准技术服务有限公司广州分公司":"SGS.pdf",
    "天津津滨华测产品检测中心有限公司":"CTI.pdf",
    "上海华测品标检测技术有限公司":"CTI.pdf",
    "华测检测认证集团股份有限公司":"CTI.pdf",
    "宁波市华测检测技术有限公司":"CTI.pdf",
    "苏州市华测检测技术有限公司":"CTI.pdf",
    // "谱尼测试集团股份有限公司":"PONY.pdf",
    "谱尼测试集团深圳有限公司":"PONY.pdf",
    "青岛谱尼测试有限公司":"PONY.pdf",
    // "广州广电计量检测股份有限公司":"广电计量.pdf",
    // "广州广电计量检测无锡有限公司":"广电计量.pdf",
    "广电计量检测（无锡）有限公司":"广电计量.pdf",
    "广电计量检测集团股份有限公司":"广电计量.pdf",
    "苏州市信测标准技术服务有限公司":"EMTEK.pdf",
    "东莞市信测科技有限公司":"EMTEK.pdf",
    "南德认证检测（中国）有限公司深圳分公司":"TUV.pdf",
    // "斯坦德检测集团股份有限公司":"STD.pdf",
    "佛山市沃特测试技术服务有限公司":"WALTEK.pdf",
    "威凯检测技术有限公司":"CVC.pdf",
    "南德认证检测（中国）有限公司上海分公司":"TUVSUD.pdf",
    "广州信测标准技术服务有限公司":"EMTEKGZ.pdf",
    "天津华测检测认证有限公司":"CTITJ.pdf",
    "中家院（北京）检测认证有限公司":"BJZJY.pdf",
    "杭州希科检测技术有限公司":"CIRS.pdf",
    "东莞市北测标准技术服务有限公司": "NTEK.pdf",
    "国高材高分子材料产业创新中心有限公司": "GGCGFZCLCYCX.pdf",
    "上海天祥质量技术服务有限公司": "Intertek.pdf",
    "莱茵技术-商检（青岛）有限公司": "LYJS.pdf",
    "必维申美商品检测（上海）有限公司": null,
},
    fileChoose:false,
  })
  const postData = reactive({
    isReplace:'2'
  })
  // 控制日期
  const disabledDate = (time) => {
    if(data.testDepartmentFlag){
      return true
    }else{
      if(postData.reportDate && time.getTime() <= postData.reportDate.getTime()){
        return true
      }else{
        return false
      }

    }
  }
  // 日期控制
  const reportDateChange = (time) => {
    if(!time){
      return
    }
    if(postData.expriryTime && postData.expriryTime.getTime() <= time.getTime()){
      postData.expriryTime = ''
    }
  }
  // 检测机构 输入
  const enterValue = (e) => {
    postData.testDepartment = e.target.value
    postData.testDepartment && changeDisabled()
  }
  // 检测机构 选择
  const testDepartmentChange = () => {
    postData.testDepartment && changeDisabled()
  }
  // 判断是否置灰/同步
  const changeDisabled = () => {
    // console.log('postData.testDepartment',postData.testDepartment)
    if(data.thirds.some(item=>item == postData.testDepartment)){
      data.testDepartmentFlag = true
    }else{
      data.testDepartmentFlag = false
    }

    data.testReportNumberFlag = false 
    setNull()
  }
  // 带出数据置空
  const setNull = () => {
    postData.testReportNumber = ''
    postData.fileUuid = ''
    postData.fileName = ''
    postData.belongTo = ''
    postData.reportDate = ''
    postData.expriryTime = ''
    postData.uuid = ''
    // 清空是否同步的
    postData.isSynchro = undefined
    data.ifAdd = false
  }
  // 打开上传
  const openUploadDialog = () => {
    if(!postData.testDepartment){
      proxy.info(h_i18n('561044839be2dd433f8e6a13cc01d4cc'))
      return
    }
    data.fileChoose = true
  }
  // 同步dialog 查看附件
  const downF = () => {
    let url = '/base/fileDownload/downloadFile?filePath='+`/basicInfo/rohshelp/${data.helpBook[postData.testDepartment]}`
    proxy.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
    proxy.httpFile({
        method: 'get',
        url: url,
        headers: { 'content-type': 'application/json' },
    }, postData.testDepartment+'.pdf').then(res=>{
      console.log(res)
    }).catch(err=>{
      proxy.warning(h_i18n('65e200d30c86a93c46dcafaa151028f5'))
    }).finally(()=>{
      proxy.closeLoading()
    })
    // window.open(`https://sqm.haier.net/readFile/basicInfo/rohshelp/${data.helpBook[postData.testDepartment]}`)
  }
  // 同步 
  const getFileUuidAndFileName = () => {
    // 判断 报告号是否存在
    //api/synFile?testReportNumber=zXcZXc&testDepartment=
    proxy.$http({
      url:'/base/newrohs/synFileByTwoParams',
      method:'post',
      data:{
        fixConfig:true,
        testReportNumber: postData.testReportNumber,
        testDepartment: postData.testDepartment,
      }
    }).then(res=>{
      if(res.data.data){
        console.log(res.data.data)
        // 附件
        postData.fileUuid = res.data.data.fileUuid
        postData.fileName = res.data.data.fileName
        // 同步其他参数
        postData.belongTo = res.data.data.belongTo
        postData.expriryTime = res.data.data.expriryTime
        postData.reportDate = res.data.data.reportDate
        postData.uuid = res.data.data.uuid
        // 是同步的报告
        postData.isSynchro = "Y"
        console.log(postData)
        proxy.success({
          message: h_i18n('19670e0858929bb2ee38ebb4105e8540'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            data.fileChoose = false
          }
        });
        // proxy.success('同步成功!!!')
        data.testReportNumberFlag = true
      }else{
        proxy.warning(h_i18n('3b15b1c8cb1ab8e2ebaee858527c3fb5') +
                            h_i18n('696b857d8de038c3d6946837e73ff1be'))
      }
    }).catch(err=>{

    }).finally(()=>{
    })
  }
  // 输入测试报告编号后 判断是否可以新增
  const getReport = () => {
    if(!postData.testReportNumber){
      tipFlag.testReportNumber = true
      setTimeout(() => {
        tipFlag.testReportNumber = false
      }, 2000);
      return
    }
    data.testReportNumberLoading = true
    // /api/reportValidateIfAdd?testReportNumber=&supplyCode=V12970
    proxy.$http({
      url:'/base/newrohs/reportValidateIfAdd',
      method:'post',
      data:{
        testReportNumber:postData.testReportNumber,
        supplyCode:postData.supplyCode,
        fixConfig:true,
      }
    }).then(res=>{
      if(res.data.data == 'Y'){
        data.ifAdd = true
        if(props.kindType == 'sqmModify'){
          // getSynFileFromRoHSReportSupply()
        }
      }else{
        proxy.warning(res.data.data || h_i18n('5ab9ee37b6e13e689bf24d93b44dab5d'))
        postData.testReportNumber = ''
        data.ifAdd = false
      }
    }).catch(err=>{
      
    }).finally(()=>{
      data.testReportNumberLoading = false
    })
  }
  // 更新时根据测试报告编号带出数据
  const getSynFileFromRoHSReportSupply = () => {
    proxy.$http({
      url:'/base/newrohs/synFileFromRoHSReportSupply',
      method:'post',
      data:{
        testReportNumber:postData.testReportNumber,
        testDepartment:postData.testDepartment,
        supplyCode:postData.supplyCode,
        fixConfig:true,
      }
    }).then(res=>{
      if(!res.data.data){
        proxy.warning(h_i18n('18d1a6b8d1efac8bf994e69b45c7acde'))
        postData.fileUuid = ''
        postData.fileName = ''
        postData.belongTo = ''
        postData.reportDate = ''
        postData.expriryTime = ''
        postData.id = ''
      }else{
        // 附件
        postData.fileUuid = res.data.data.fileUuid
        postData.fileName = res.data.data.fileName
        // 同步其他参数
        postData.belongTo = res.data.data.belongTo
        postData.reportDate = res.data.data.reportDate
        postData.expriryTime = res.data.data.expriryTime
        postData.id = res.data.data.id
        // 是同步的报告
        postData.isSynchro = "Y"
      }
    }).catch(err=>{

    }).finally(()=>{
    })
  }
  // 获取 已有测试编号 /base/newrohs/selectReport?report
  const getTestReportList = () =>{
    proxy.$http({
      url:'/base/newrohs/selectReport?report=&supplierNo=' + postData.supplyCode,
      method:'get',
    }).then(res=>{
      data.testReportList = res.data.data.map(item=>{
        return {testReportNumberOld:item.testReportNumber}
      })
    }).catch(err=>{

    }).finally(()=>{

    })
  }
  // 查找原测试编号
  const testReportNumberOldChange = () => {
    // api/reportValidateIfReplace
    proxy.$http({
      url:'/base/newrohs/reportValidateIfReplace',
      method:'post',
      data:{
        fixConfig:true,
        testReportNumberOld: postData.testReportNumberOld,
        supplyCode: postData.supplyCode
      },
    }).then(res=>{
      if(res.data.data == 'Y'){
        
      }else{
        proxy.warning(res.data.data || h_i18n('9e04e32d2e1e45b904a6aaf8a5d9982b'))
        postData.testReportNumberOld = ''
      }
    }).catch(err=>{

    }).finally(()=>{
    })
  }

  // 提交校验
  const submit = () => {
    console.log(postData)
    if(!postData.supplyCode || !postData.supplyName || !postData.submitPerson){
      proxy.warning(h_i18n('d26e7275f9cd553afc85b43d5cc99f45'))
      return
    }
    if(postData.testReportNumber && !data.ifAdd){
      proxy.warning(h_i18n('7530410e5185a3d663665fcbaf18d370'))
      return
    }
  if (!postData.testDepartment) {
    tipFlag.testDepartment = true
    setTimeout(() => {
      tipFlag.testDepartment = false
    }, 2000);
    return
  }
  if (!postData.testReportNumber) {
    tipFlag.testReportNumber = true
    setTimeout(() => {
      tipFlag.testReportNumber = false
    }, 2000);
    return
  }
  if (!postData.fileUuid) {
    tipFlag.fileUuid = true
    setTimeout(() => {
      tipFlag.fileUuid = false
    }, 2000);
    return
  }
  if (!postData.belongTo) {
    tipFlag.belongTo = true
    setTimeout(() => {
      tipFlag.belongTo = false
    }, 2000);
    return
  }
  if (!postData.reportDate) {
    tipFlag.reportDate = true
    setTimeout(() => {
      tipFlag.reportDate = false
    }, 2000);
    return
  }
  if (!postData.expriryTime) {
    tipFlag.expriryTime = true
    setTimeout(() => {
      tipFlag.expriryTime = false
    }, 2000);
    return
  }
  if(props.kindType == 'sqmModify'){
    // console.log(postData.uuid)
    postData.testReportNumberOld = props.getData.testReportNumber
  }
  if(postData.isReplace == '1' && !postData.testReportNumberOld){
    tipFlag.testReportNumberOld = true
    setTimeout(() => {
      tipFlag.testReportNumberOld = false
    }, 2000);
    return
  }
  if (!postData.uuid) {
    tipFlag.uuid = true
    setTimeout(() => {
      tipFlag.uuid = false
    }, 2000);
    return
  }
  if(postData.isReplace == '1' && postData.testReportNumberOld){
    proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('afa182fd6c08abb16a608d971d7c7828'),confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),callback:(action)=>{
      if(action == 'confirm'){
        sub()
      }
    }})
  }else{
    sub()
  }
  
  // 修改的直接提交
  // props.kindType == 'sqmModify' && (data.subLoading = true) && emit('submitBtnUpdate',postData)
  }
  // 提交方法 先验证检测数据
  const sub = () => {
    data.subLoading = true
  proxy.$http({
    url:'/base/newrohs/queryCheckDateList',
    method:'post',
    data:{
      uuid:postData.uuid,
      fixConfig:true,
    }
  }).then(res=>{
    console.log(res.data.data.length)
    if(res.data.data?.length > 0){
      // 验证成功 可以提交
      props.kindType == 'sqmModify' ? emit('submitBtnUpdate',postData) : emit('submitBtn',postData)
    }else{
      tipFlag.uuid = true
      setTimeout(() => {
        tipFlag.uuid = false
      }, 2000);
      return
    }
  }).catch(err=>{

  }).finally(()=>{
    data.subLoading = false
  })
  }
  const back = () => {
    emit("backBtn")
  }

  /**
 * 传高度
 */
const changeMethod = () => {
  proxy.postThisPageHeight();
};
const inspectionUpdate = () => {
  proxy.postThisPageHeight();
    }

    /**
 * 错误提示
 */
 const errorFile = (str) => {
  proxy.warning({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str})
}

// 支持老附件下载
const openFile = (uuid,name) => {
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
  // https://sqm.haier.net/downLoadFileNew?type=5&fileUUID=2024/02/03/284771ef-a758-434c-bf22-157de2839076.jpg
  let url = ''
  if(uuid.includes('http')){
    url = "/base/fileDownload/downloadFile?filePath="+uuid.split('https://sqm.haier.net/readFile/')[1]
  }else{
    // let uid = process.env.NODE_ENV === "production" ? "https://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    url = '/base/fileDownload/downLoadFileFtp?type=4&fileUUID='+uuid
    //   window.open(url)
    //   proxy.closeLoading()
    //   return
  }
  // proxy.startLoading('下载中...')
  proxy.httpFile({
    method: "get",
    url: url,
    headers: {'content-type': 'application/json'},
  }, name)
}

/**
 * h-file-upload 上传文件
 */
const fileChange = (file,f) => {
  
    postData.fileName = file.name
    
    let formData = new FormData()
    formData.append('files', file.file)
    proxy.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
    proxy.$http({
      method: "POST",
      url: "/base/fileUpload/uploadToOssSaveUrl",
      data: formData
    }).then(res => {
      if (res.data.code === "0") {
        postData.fileUuid = res.data.data
        data.fileChoose = false
      } else {
        proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
        data.fileTemp = null
      }
    }).catch(err=>{
      proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
      data.fileTemp = null
    }).finally(()=>{
      proxy.closeLoading()
    })
  
}
/**
 * h-file-upload 下载
 */
const download = () =>{
  
    proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
    proxy.httpFile({
      method: "get",
      url: "/base/fileDownload/downloadFile?filePath="+postData.fileUuid.split('https://sqm.haier.net/readFile/')[1],
      headers: {'content-type': 'application/json'},
    }, postData.fileName)
}

/**
 * h-file-upload 删除
 */
const deleteFun = () =>{
    postData.fileUuid = ''
    postData.fileName = ''
    data.fileTemp = {}  
}

const openRohsDetectDataModify = () => {
  if(props.getData.uuid){
    console.log('openRohsDetectDataModify',props.getData.uuid)
  }else{
    // 生成 uuid
    // postData.uuid = getUuid()
    // console.log('openRohsDetectDataModify',postData.uuid)
  }

  proxy.$router.push({
      name: "rohsDetectDataModify",
      query: {
        trueName:data.trueName || props.getData.trueName,
        userName:data.userName || props.getData.userName,
        supplyCode:data.supplyCode || props.getData.supplyCode,
        supplyName:data.supplyName || props.getData.supplyName,
        // uuid:props.getData.uuid,
        dataFrom:'sqm',
        kindType:'sqmModify',
        uuid:postData.uuid || props.getData.uuid
      }
    })
  // 打开检测数据编辑页面
}
const openRohsDetectDataAdd = () => {
  if(props.kindType == 'sqmModify'){
    // 更新数据优先生成新uuid
    postData.uuid = getUuid()
  }else if(props.getData.uuid){
    console.log('openRohsDetectDataAdd-old',props.getData.uuid)
  }else{
    // 生成 uuid
    postData.uuid = getUuid()
    console.log('openRohsDetectDataAdd-new',postData.uuid)
  }

  proxy.$router.push({
      name: "rohsDetectDataModify",
      query: {
        trueName:data.trueName || props.getData.trueName,
        userName:data.userName || props.getData.userName,
        supplyCode:data.supplyCode || props.getData.supplyCode,
        supplyName:data.supplyName || props.getData.supplyName,
        // uuid:props.getData.uuid,
        dataFrom:'sqm',
        kindType:'sqmAdd',
        uuid:postData.uuid  || props.getData.uuid
      }
    })
  // 打开检测数据编辑页面
}

const openRohsDetectDataDetail = () => {
  console.log('openRohsDetectDataDetail',props.getData.uuid)
  proxy.$router.push({
    name: props.kindType == 'sqmDetail' || props.kindType == 'sqmModify' ? 'rohsDetectDataDetail' : 'detailOfRohsDetectData',
    query: {
      trueName:data.trueName || props.getData.trueName,
      userName:data.userName || props.getData.userName,
      name:data.name || props.getData.name,
      nickName:data.nickName || props.getData.nickName,
      supplyCode:data.supplyCode || props.getData.supplyCode,
      supplyName:data.supplyName || props.getData.supplyName,
      uuid:props.getData.uuid || undefined,
      reportId:props.getData.reportId || undefined,
      dataFrom: props.kindType == 'sqmDetail' || props.kindType == 'sqmModify' ? 'sqm' : 'hmqm',
      kindType: props.kindType == 'sqmDetail' || props.kindType == 'sqmModify' ? 'sqmDetail' : 'hmqmDetail'
    }
  })
}


const getUuid = () => {
            //32长度
            var len = 32;
            //16进制
            var radix = 16;
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [], i;
            radix = radix || chars.length;
            if(len) {
                for(i = 0; i < len; i++)uuid[i] = chars[0 | Math.random() * radix];
            } else {
                var r;
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';
                for(i = 0; i < 36; i++) {
                    if(!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                    }
                }
            }
            aNewUUID.value = aNewUUID.value || uuid.join('')
            return aNewUUID
        }

onBeforeMount(()=>{
  props.kindType == 'sqmAdd' && (data.title = h_i18n('491411e0ae5d09d5eca25a2b2f275e3b'))
  props.kindType == 'sqmModify' && (data.title = h_i18n('32ac152be1911e9360047dcb0898cf70'))
  props.kindType == 'sqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a'))
  props.kindType == 'hmqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a'))
  postData.supplyCode = props.getData.supplyCode || route.query.supplyCode
  postData.supplyName = props.getData.supplyName || route.query.supplyName
  postData.submitPerson = props.getData.trueName || route.query.trueName
})

onMounted(()=>{
  getTestReportList()
  if(props.kindType == 'sqmModify'){
    // RoHS报告更新 不用回填
    // postData.testDepartment = props.getData.testDepartment
    // postData.testReportNumber = props.getData.testReportNumber
    // postData.fileUuid = props.getData.fileUuid
    // postData.fileName = props.getData.fileName
    // postData.isReplace = props.getData.isReplace
    // postData.testReportNumberOld = props.getData.testReportNumberOld
    // postData.submitPerson = props.getData.submitPerson
    // postData.supplyCode = props.getData.supplyCode
    // postData.reportDate = props.getData.reportDate
    // postData.expriryTime = props.getData.expriryTime
    // postData.belongTo = props.getData.belongTo
    // postData.uuid = props.getData.uuid
  }
})
onBeforeUnmount(()=>{

})
onUpdated(()=>{

})
onBeforeRouteLeave((to,from,next)=>{
  // console.log(to)
  // console.log(from)
  if('rohsDetectDataModify' == to.name){
    // from.meta.keepAlive = true;
    next()
  }else{
    // from.meta.keepAlive = false;
    for (const key in postData) {
      if(key == 'isReplace' || key == 'submitPerson' || key == 'supplyCode' || key == 'supplyName'){
      }else{
        postData[key] = undefined
      }
    };
    postData.isReplace = '2'
    getTestReportList()
    data.fileTemp = {}
    next()
  }
})
</script>

<style lang="scss">
.ComponentRohsReport_style{
 .top_wrap_style{
  div{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
 }
 .over_dialog_style{
  .el-row{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .el-row:hover{
    div{
      white-space: normal;
      height: 100% !important;
    }
  }
 }
}
</style>